import { Route } from "@/routes/routes.types";

/**
 * Create routes object where each route has its path and params
 */
export const routes = {
    administration: {
        path: "/administration",
    },
    officeMap: {
        path: "/map",
    },
    navPointManagement: {
        path: "/nav-point-management",
    },
} as const satisfies Record<string, Route>;

/**
 * Define Routes type representing all the defined routes
 */
export type Routes = typeof routes;

/**
 * Define RoutesPaths type union of all routes paths
 */
export type RoutesPaths = Routes[keyof Routes]["path"];
